import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { fetchAppointments } from "../../../store/features/appointments/appointmentsActions";
import { fetchAgendas } from "../../../store/features/agendas/agendasActions";
import CalendarSidebar from "./CalendarSidebar";
import FilterPanel from "./FilterPanel";
import CalendarView from "./CalendarView";
import AppointmentDetailsModal from "../Appointments/AppointmentDetailsModal";
import BookAppointmentModal from "../Appointments/BookAppointmentModal";
import { useNavigate, useParams } from "react-router-dom";
const CalendarDashboard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const onBack = () => {
    navigate(`/assignbusiness/${params?.businessId}`);
  };

  useEffect(() => {
    dispatch(fetchAppointments());
    dispatch(fetchAgendas());
  }, [dispatch]);

  return (
    <div fluid className="fade-in">
      <div className="d-flex me-auto mb-sm-0">
        <span
          style={{ fontSize: "18px", cursor: "pointer" }}
          className="d-flex justify-content-start align-items-center me-3"
          onClick={onBack}
        >
          <i className="fa fa-arrow-left"></i>
        </span>
        <h4 className="card-title"> Calendars</h4>
      </div>
      <div className="card-header d-sm-flex align-items-center d-block"></div>
      <Row className="g-3">
        {/* Sidebar */}
        <Col lg={3}>
          <CalendarSidebar />
        </Col>

        {/* Main Content */}
        <Col lg={9}>
          {/* <FilterPanel /> */}
          <CalendarView />
        </Col>
      </Row>

      {/* Modals */}
      <AppointmentDetailsModal />
      <BookAppointmentModal />
    </div>
  );
};

export default CalendarDashboard;
